export default "skymp5-front/8ef873d948b858b0bfbb5308538aa71d.png";